// extracted by mini-css-extract-plugin
module.exports = {"container":"_1AKdm8ilH3SXkHAEVGYcK1","groupsList":"_1nf-wyz5ziW6HDOgBHTT_r"};